module.exports = __webpack_public_path__ + "img/icon-event.26f7ece7.png";